import "../../css/components/Collage.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import g from "../utils/globals";
import Dynamic from "./Dynamic";
import Link from "./Link";

const percentage = number => `${number}%`;

class CollageItem extends Component {
  componentDidMount = () => {
    if (this.props.module === "Text" && g.editMode) {
      document.getElementById(this.props.id).addEventListener("keydown", this.checkKeyCode, false);
    }
  };

  componentWillUnmount = () => {
    if (this.props.module === "Text" && g.editMode) {
      document.getElementById(this.props.id).removeEventListener("keydown", this.checkKeyCode, false);
    }
  };

  getStyle = () => {
    const bounds = this.props.bounds;
    const css = this.props.styles;
    return {
      width: percentage(bounds.width),
      left: percentage(bounds.left),
      marginTop: percentage(bounds.top),
      zIndex: 490 - this.props.index,
      transform: bounds.rotation ? `rotate(${bounds.rotation * -1}deg)` : "",
      transformOrigin: bounds.rotation ? "top left" : "",
      ...css,
    };
  };

  checkKeyCode = e => {
    // document.execcommand(inserthtml doesn't work ...
    // check keycode avoiding creation of new element
    const code = e.keyCode ? e.keyCode : e.which;
    if (code === 13 && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  render = () => {
    const className = `collage-item ${this.props.filters.devices.join("")} ${this.props.belongs || ""}`;
    const renderLink = (child, isVideo) => (
      <Link
        dataAttrs={this.props.dataAttrs}
        href={this.props.targetUrl}
        className={className}
        style={!isVideo ? this.getStyle() : null}
        index={this.props.index}
        position={this.props.position}
        id={this.props.id}
        carousel={this.props.carousel}
        onclick={this.props.onclick}
        customProps={this.props.customProps}
        analytics={this.props.analytics}
      >
        {child}
      </Link>
    );
    // Video has events for mute and unmute
    if (this.props.targetUrl || this.props.onclick) {
      if (this.props.module === "Video") {
        return (
          <div id={this.props.id} style={this.getStyle()} className={className} {...this.props.dataAttrs}>
            <Dynamic {...this.props} renderLink={renderLink} />
          </div>
        );
      }
      return renderLink(<Dynamic {...this.props} />);
    }
    if (this.props.module === "Text" && g.editMode) {
      if (!this.props.dataAttrs) this.props.dataAttrs = {};
      this.props.dataAttrs.contentEditable = true;
      this.props.dataAttrs.suppressContentEditableWarning = true;
    }
    return (
      <div id={this.props.id} style={this.getStyle()} className={className} {...this.props.dataAttrs}>
        <Dynamic {...this.props} />
      </div>
    );
  };
}

CollageItem.defaultProps = {
  position: 0,
  bounds: {
    width: 100,
    left: 0,
    top: 0,
  },
  customProps: {},
};

CollageItem.propTypes = {
  id: PropTypes.string,
  index: PropTypes.number,
  position: PropTypes.number,
  filters: PropTypes.shape({
    devices: PropTypes.array.isRequired,
  }).isRequired,
  bounds: PropTypes.shape({
    width: PropTypes.any,
    height: PropTypes.any,
    left: PropTypes.any,
    top: PropTypes.any,
  }),
};

export default CollageItem;
